import React from "react";
import { RotateCcw } from "lucide-react";

const SettingsPanel = ({ isOpen, names, setNames, onReset }) => {
  if (!isOpen) return null;

  return (
    <div className="bg-stone-50 border-b border-stone-200 p-4 animate-in slide-in-from-top-2">
      <div className="max-w-3xl mx-auto space-y-4">
        <h3 className="font-semibold text-xs text-stone-400 uppercase tracking-widest">
          Configuration
        </h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-stone-400 block mb-1">
              Your Name
            </label>
            <input
              value={names.you}
              onChange={(e) => setNames({ ...names, you: e.target.value })}
              className="w-full p-2 border border-stone-200 rounded text-sm focus:border-[#1F6F54] focus:outline-none"
            />
          </div>
          <div>
            <label className="text-xs text-stone-400 block mb-1">
              Partner Name
            </label>
            <input
              value={names.partner}
              onChange={(e) => setNames({ ...names, partner: e.target.value })}
              className="w-full p-2 border border-stone-200 rounded text-sm focus:border-[#1F6F54] focus:outline-none"
            />
          </div>
        </div>
        <div className="pt-2 flex justify-end">
          <button
            onClick={onReset}
            className="text-xs text-rose-500 hover:text-rose-700 flex items-center gap-1"
          >
            <RotateCcw className="w-3 h-3" /> Reset App Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
